<div class="ui-modal save-vehicles-dialog">
  <div class="header flex-row space-between-center">
    {{ 'VEHICLES.SAVE_DIALOG.TITLE' | translate: { count: vehicles.length } }}
    <span class="ui-icon-close c-p" (click)="closeDialog()"></span>
  </div>

  <div class="body flex-col start-start flex gap-16 dialog-content">
    <div class="flex-col gap-16 w-100">
      @for (vehicle of vehicles; track vehicle.plate; let index = $index) {
        <div class="vehicle-row">
          <ui-vehicle-icon [vehicle]="vehicle"></ui-vehicle-icon>

          <div class="vehicle-fields-grid" [formGroup]="vehicleForms.controls[index]">
            <div class="flex-col gap-8 w-100">
              <label [for]="'vehicle-owner-' + index">{{ 'ADD_VEHICLE_MANUAL_MODAL.NAME' | translate }}</label>
              <input
                [id]="'vehicle-owner-' + index"
                type="text"
                formControlName="owner"
                [placeholder]="'ADD_VEHICLE_MANUAL_MODAL.NAME' | translate"
                class="ui-input ui-input-40"
              >
            </div>

            <div class="flex-col gap-8 w-100">
              <label [for]="'vehicle-plate-' + index">{{ 'ADD_VEHICLE_MANUAL_MODAL.PLATE' | translate }}</label>
              <input
                [id]="'vehicle-plate-' + index"
                type="text"
                formControlName="plate"
                [placeholder]="'ADD_VEHICLE_MANUAL_MODAL.PLATE' | translate"
                class="ui-input ui-input-40"
              >
            </div>

            <div class="flex-col gap-8 w-100">
              <label>{{ 'ADD_VEHICLE_MANUAL_MODAL.MAKE' | translate }}</label>
              <mat-select
                class="ui-selector"
                formControlName="make"
                [placeholder]="'ADD_VEHICLE_MANUAL_MODAL.MAKE' | translate"
              >
                @for (carName of carMakes; track carName) {
                  <mat-option [value]="carName">{{ carName }}</mat-option>
                }
              </mat-select>
            </div>

            <div class="flex-col gap-8 w-100">
              <label>{{ 'ADD_VEHICLE_MANUAL_MODAL.COLOR' | translate }}</label>
              <ui-color-select
                [inline]="false"
                [single]="true"
                formControlName="color"
              ></ui-color-select>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="footer flex-row end-center gap-8">
    <ui-button
      type="secondary"
      [text]="'COMMON.CANCEL' | translate"
      [disabled]="isAddingVehiclesToGroups()"
      (clickAction)="closeDialog()"
    ></ui-button>
    <ui-button
      type="primary"
      [text]="'COMMON.SAVE' | translate"
      [disabled]="!areVehiclesValid() || isAddingVehiclesToGroups()"
      [loading]="isAddingVehiclesToGroups()"
      (clickAction)="saveVehicles()"
    ></ui-button>
  </div>
</div>
